import {isArray} from "lodash"

import mutateDriverForV2 from "./mutateDriverForV2"


export default (drivers) => {
  if (!isArray(drivers)) return drivers

  return drivers.map(mutateDriverForV2)
}
